import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [{
	path: '/',
	redirect: {
		name: 'index'
	},
	component: layoutHeaderAside,
	children: [
		// 首页
		{
			path: 'index',
			name: 'index',
			meta: {
				auth: true
			},
			component: _import('system/index')
		},
		{
			path: 'AccountManagement',
			name: 'AccountManagement',
			meta: {
				title: '账号管理',
				auth: true
			},
			component: _import('demo/AccountManagement')
		},
		{
			path: 'AuthorityManagement',
			name: 'AuthorityManagement',
			meta: {
				title: '权限管理',
				auth: true
			},
			component: _import('demo/AuthorityManagement')
		},
		{
			path: 'Manager',
			name: 'Manager',
			meta: {
				title: '管理员',
				auth: true
			},
			component: _import('demo/Manager')
		},
		{
			path: 'Salesman',
			name: 'Salesman',
			meta: {
				title: '业务员',
				auth: true
			},
			component: _import('demo/Salesman')
		},
		{
			path: 'ExaminationApproval',
			name: 'ExaminationApproval',
			meta: {
				title: '审批',
				auth: true
			},
			component: _import('demo/ExaminationApproval')
		},
		{
			path: 'Absence',
			name: 'Absence',
			meta: {
				title: '请假类型',
				auth: true
			},
			component: _import('demo/Absence')
		},
		{
			path: 'AttendanceSet',
			name: 'AttendanceSet',
			meta: {
				title: '考勤设置',
				auth: true
			},
			component: _import('demo/AttendanceSet')
		},
		{
			path: 'VisitRoute',
			name: 'VisitRoute',
			meta: {
				title: '拜访路线',
				auth: true
			},
			component: _import('demo/VisitRoute')
		},
		{
			path: 'CustomerManagement',
			name: 'CustomerManagement',
			meta: {
				title: '客户信息管理',
				auth: true
			},
			component: _import('demo/CustomerManagement')
		},
		{
			path: 'EquipmentManagement',
			name: 'EquipmentManagement',
			meta: {
				title: '设备管理',
				auth: true
			},
			component: _import('demo/EquipmentManagement')
		},

		{
			path: 'PurchaseOrder',
			name: 'PurchaseOrder',
			meta: {
				title: '下单开单',
				auth: true
			},
			component: _import('demo/PurchaseOrder')
		},
		{
			path: 'agreement',
			name: 'agreement',
			meta: {
				title: '相关协议',
				auth: true
			},
			component: _import('demo/agreement')
		},
		{
			path: 'Companydetails',
			name: 'Companydetails',
			meta: {
				title: '公司详情',
				auth: true
			},
			component: _import('demo/Companydetails')
		},
		{
			path: 'AssignAccountNumber',
			name: 'AssignAccountNumber',
			meta: {
				title: '分配账号',
				auth: true
			},
			component: _import('demo/AssignAccountNumber')
		},
		{
			path: 'InvitationCode',
			name: 'InvitationCode',
			meta: {
				title: '邀请码',
				auth: true
			},
			component: _import('demo/InvitationCode')
		},
		{
			path: 'EventProducts',
			name: 'EventProducts',
			meta: {
				title: '活动产品',
				auth: true
			},
			component: _import('demo/EventProducts')
		},
		{
			path: 'Productentry',
			name: 'Productentry',
			meta: {
				title: '普通产品',
				auth: true
			},
			component: _import('demo/Productentry')
		},
		{
			path: 'ProfitCount',
			name: 'ProfitCount',
			meta: {
				title: '提成统计',
				auth: true
			},
			component: _import('demo/ProfitCount')
		},
		{
			path: 'InformationDelivery',
			name: 'InformationDelivery',
			meta: {
				title: '信息发布',
				auth: true
			},
			component: _import('demo/InformationDelivery')
		},
		{
			path: 'fileManagement',
			name: '文件管理',
			meta: {
				title: '信息发布',
				auth: true
			},
			component: _import('demo/fileManagement')
		},
		{
			path: 'HistoricalVisit',
			name: '历史拜访',
			meta: {
				auth: true
			},
			component: _import('demo/HistoricalVisit')
		},
		{
			path: 'BusinesPersonnel',
			name: '业务人员',
			meta: {
				auth: true
			},
			component: _import('demo/BusinesPersonnel')
		},
		{
			path: 'folderManagement',
			name: '文件夹管理',
			meta: {
				auth: true
			},
			component: _import('demo/folderManagement')
		},
		{
			path: 'RouteManagement',
			name: '路线管理',
			meta: {
				auth: true
			},
			component: _import('demo/RouteManagement')
		},
		{
			path: 'Recharge',
			name: '充值',
			meta: {
				auth: true
			},
			component: _import('demo/Recharge')
		},
		{
			path: 'HistoricalVisits',
			name: '客户历史拜访',
			meta: {
				auth: true
			},
			component: _import('demo/HistoricalVisits')
		},
		{
			path: 'BookingManagement',
			name: '预约管理',
			meta: {
				auth: true
			},
			component: _import('demo/BookingManagement')
		},
		
		
		
		// {
		// 	path: 'assembly',
		// 	name: '组件',
		// 	meta: {
		// 		auth: true
		// 	},
		// 	component: _import('demo/assembly')
		// },


		// 系统 前端日志
		{
			path: 'log',
			name: 'log',
			meta: {
				title: '前端日志',
				auth: true
			},
			component: _import('system/log')
		},
		// 刷新页面 必须保留
		{
			path: 'refresh',
			name: 'refresh',
			hidden: true,
			component: _import('system/function/refresh')
		},
		// 页面重定向 必须保留
		{
			path: 'redirect/:route*',
			name: 'redirect',
			hidden: true,
			component: _import('system/function/redirect')
		}
	]
}]

/**
 * 在主框架之外显示
 */
const frameOut = [
	// 登录
	{
		path: '/login',
		name: 'login',
		component: _import('system/login')
	}
]

/**
 * 错误页面
 */
const errorPage = [{
	path: '*',
	name: '404',
	component: _import('system/error/404')
}]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
	...frameIn,
	...frameOut,
	...errorPage
]
